import facePageStyles from '../views/facePageStyles';
import assocGroupStyles from './assocGroupStyles';

const noteAssocGroupStyles = (theme) => ({
  ...facePageStyles(theme),
  ...assocGroupStyles(theme),
});

export default noteAssocGroupStyles;
